export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL?.trim() || "",
  v1Path: '/api/v1'
};
